module.exports = __webpack_public_path__ + "static/media/header@3x.25054609.png";